import { TicketRoleEnum } from '../types/Ticket';

/** Older tickets omit the role. The API treats that as the registration holder. */
export function isTeamRegistrationRole(ticketRole: TicketRoleEnum | null | undefined): boolean {
  return ticketRole == null || ticketRole === TicketRoleEnum.REGISTRATION;
}

export function captainAfterTicketTransfer<T>(input: {
  isTeamsEvent: boolean;
  isTeamRegistrationTicket: boolean;
  wasCaptain: boolean;
  currentCaptain: T[] | undefined;
  replacement: T;
}): T[] {
  if ((input.isTeamsEvent && input.isTeamRegistrationTicket) || input.wasCaptain) {
    return [input.replacement];
  }
  return input.currentCaptain ?? [];
}

export function teamAfterUnsavedPlayerRemoval<
  T extends { users: Array<{ id: number }>; captain?: Array<{ id: number }> | null }
>(team: T, removedUserId: number): T {
  const removedCaptain = team.captain?.[0]?.id === removedUserId;
  return {
    ...team,
    users: team.users.filter((user) => user.id !== removedUserId),
    ...(removedCaptain ? { captain: [] } : {}),
  };
}

/**
 * A captain who is not already on a full roster stays off it.
 * Dropping someone else would revoke that player's roster ticket on the next save.
 */
export function rosterAfterNewCaptain<T extends { id: number }>(input: {
  users: T[];
  captain: T;
  maxRoster: number;
}): { users: T[]; overflow: boolean } {
  if (input.users.some((user) => user.id === input.captain.id)) {
    return { users: input.users, overflow: false };
  }
  if (input.users.length >= input.maxRoster) {
    return { users: input.users, overflow: true };
  }
  return { users: [input.captain, ...input.users], overflow: false };
}
